// Generated from build58 src/features/musicEdition/model.ts; do not edit.
// Catalog root categories are not a listener's musical genre. Match whole
// labels only: Children's Music / 음악극 and other real genres remain intact.
export const editionGenres = (genres) => [
  ...new Set((genres ?? []).map((g) => g.trim()).filter((g) => g && !/^(music|음악)$/i.test(g))),
];
export const editionThemes = {
  artwork: {
    background: '#17191B',
    text: '#FFFFFF',
    muted: '#F3F0EB',
    accent: '#FFFFFF',
    tile: '#343739',
  },
  paper: {
    background: '#F3EEE5',
    text: '#181818',
    muted: '#645F57',
    accent: '#F16438',
    tile: '#DFD8CD',
  },
  night: {
    background: '#17191B',
    text: '#F8F3E9',
    muted: '#B3B4AF',
    accent: '#FF9777',
    tile: '#343739',
  },
  orange: {
    background: '#FF6B3E',
    text: '#1B1916',
    muted: '#4B281C',
    accent: '#1B1916',
    tile: '#E7552A',
  },
};
// /me/reviews uses DateTimeUtils.toDateString: a Seoul calendar date (yyyy.M.d).
export function editionTimestamp(value) {
  if (!value) return NaN;
  const parts = /^(\d{4})[.-](\d{1,2})[.-](\d{1,2})$/.exec(value);
  if (parts) {
    const year = Number(parts[1]);
    const month = Number(parts[2]);
    const day = Number(parts[3]);
    const date = new Date(Date.UTC(year, month - 1, day));
    return date.getUTCFullYear() === year &&
      date.getUTCMonth() === month - 1 &&
      date.getUTCDate() === day
      ? date.getTime()
      : NaN;
  }
  return NaN;
}
export function plainReview(content) {
  // Both MyReviewForm (web) and ReviewEditorScreen (native) submit plain text.
  // SVG Text already escapes it: never infer HTML from a user's literal words.
  return content.replace(/\s+/g, ' ').trim();
}
export function excerpt(content, length = 110) {
  const text = plainReview(content);
  const chars = Array.from(text);
  return chars.length <= length ? text : `${chars.slice(0, length - 1).join('')}…`;
}
// Select a literal Unicode range from the normalized original, never generated copy.
export function reviewRange(content, start = 0, length = 90) {
  const chars = Array.from(plainReview(content));
  const safeStart = Math.max(
    0,
    Math.min(Math.max(0, chars.length - 1), Number.isFinite(start) ? Math.floor(start) : 0),
  );
  return chars
    .slice(safeStart, safeStart + Math.max(1, Math.min(110, Math.floor(length) || 90)))
    .join('');
}
const stopWords = new Set(
  '그리고 하지만 그래서 정말 너무 그냥 조금 가장 음악 앨범 노래 트랙 이번 이건 그건 나는 내가 있는 없는 좋은 좋다 좋고 좋음 좋았다 좋았던 좋습니다 좋네요 이런 그런 저런 어떤 이거 그거 이것 그것 저것 같다 같은 같고 같다 생각 생각이 생각하는 개인적으로 사실 역시 아직 다시 많이 매우 항상 계속 모든 때문 정도 하나 정말로 들었다 듣고 듣는 들으면 이다 있다 없다 했다 한다 하는 하며 해서 했던 된다 되는 the and this that with from have album music very really good great like just was were are is has had its for not but you your my me it of to in on as an'.split(
    ' ',
  ),
);
const commonWords = new Set(
  "또 또한 좀 더 덜 것 걸 게 건 수 듯 듯한 대한 대해 통해 위한 위해 어떤가 어떻게 이렇게 그렇게 저렇게 때문에 만큼 여기 저기 이 곡 곡들 곡이 곡을 앨범이 앨범을 앨범의 음악이 음악을 음악의 느낌 느낌이 느낌의 생각한다 좋게 좋았고 좋았어요 좋은데 좋지만 좋다는 있다는 있다는점 있었다 있는데 있어서 있을 없다 없고 없는듯 없습니다 듣기 들을 들은 들으니 들으면서 되어 되고 했고 하는데 합니다 했다면 있다면 a be been being am do does did done will would can could should may might must also more most much some any all every only even still than then there here these those they them their we us our his her she he who what which when where why how into out up down about over under because so if no yes really don't doesn't didn't isn't wasn't it's that's i'm i've i'd".split(
    ' ',
  ),
);
// Strip Korean particles only when the base is a known music noun OR appears
// independently in this member's reviews. Never guess stems such as '있'/'좋'.
const musicNouns = new Set(
  '기타 베이스 드럼 보컬 피아노 신스 신디사이저 멜로디 리듬 사운드 비트 편곡 화성 가사 음색 연주 프로덕션 믹싱 마스터링 그루브 코러스 후렴 랩 플로우 훅 샘플링 재즈 록 힙합 소울 팝 전자음 앰비언트 디스토션 스트링 트럼펫 색소폰 감성 여운 긴장감 몰입감 에너지 공간감 질감 서사'.split(
    ' ',
  ),
);
const koreanParticles = [
  '으로부터',
  '에게서는',
  '에서는',
  '으로는',
  '에서의',
  '까지도',
  '이라도',
  '이라고',
  '보다는',
  '만으로',
  '에서도',
  '에게서',
  '으로',
  '에서',
  '처럼',
  '보다',
  '까지',
  '부터',
  '에게',
  '한테',
  '마저',
  '조차',
  '이랑',
  '에는',
  '과의',
  '와의',
  '이나',
  '이며',
  '은',
  '는',
  '이',
  '가',
  '을',
  '를',
  '의',
  '에',
  '와',
  '과',
  '도',
  '만',
];
export function reviewWordTokens(content) {
  return (
    plainReview(content)
      .normalize('NFC')
      .toLocaleLowerCase()
      .replace(/[’‘]/g, "'")
      .match(/\p{L}+(?:['-]\p{L}+)*/gu) ?? []
  ).filter((word) => Array.from(word).length >= 2 && Array.from(word).length <= 18);
}
export function reviewWords(records) {
  const counts = new Map();
  const vocabulary = new Set(records.flatMap((r) => reviewWordTokens(r.review.content)));
  const seenReviews = new Set();
  for (const r of records) {
    if (seenReviews.has(r.review.id)) continue;
    seenReviews.add(r.review.id);
    const words = new Set(
      reviewWordTokens(r.review.content).map((word) => {
        if (!/^[가-힣]+$/.test(word) || musicNouns.has(word)) return word;
        for (const particle of koreanParticles)
          if (word.endsWith(particle)) {
            const base = word.slice(0, -particle.length);
            if (base.length >= 2 && (musicNouns.has(base) || vocabulary.has(base))) return base;
          }
        return word;
      }),
    );
    for (const word of words)
      if (!stopWords.has(word) && !commonWords.has(word)) {
        const prior = counts.get(word) ?? { word, count: 0, reviewIds: [] };
        prior.count++;
        prior.reviewIds.push(r.review.id);
        counts.set(word, prior);
      }
  }
  return [...counts.values()]
    .filter((w) => w.count >= 2)
    .sort((a, b) => b.count - a.count || a.word.localeCompare(b.word))
    .slice(0, 40);
}
export function buildEdition(items, period, now = new Date()) {
  const today = new Date(now.getTime() + 9 * 60 * 60 * 1000);
  // A canonical merge can retain two review records for one album. Count the latest only.
  const unique = new Map();
  for (const item of items) {
    if (
      item.review.isHistorical ||
      !Number.isFinite(item.review.rating) ||
      item.review.rating < 0 ||
      item.review.rating > 5
    )
      continue;
    const old = unique.get(item.album.id);
    const time =
      editionTimestamp(item.review.updatedAt) || editionTimestamp(item.review.createdAt) || 0;
    const oldTime = old
      ? editionTimestamp(old.review.updatedAt) || editionTimestamp(old.review.createdAt) || 0
      : -1;
    if (!old || time > oldTime || (time === oldTime && item.review.id > old.review.id))
      unique.set(item.album.id, item);
  }
  const records = [...unique.values()]
    .filter((item) => {
      if (period === 'all') return true;
      const date = new Date(editionTimestamp(item.review.createdAt));
      return (
        date.getUTCFullYear() === today.getUTCFullYear() &&
        (period === 'year' || date.getUTCMonth() === today.getUTCMonth())
      );
    })
    .sort((a, b) => b.review.rating - a.review.rating || a.album.id - b.album.id);
  const genres = new Map();
  const artists = new Map();
  records.forEach((item) => {
    for (const genre of editionGenres(item.album.genres)) {
      const bucket = genres.get(genre) ?? { count: 0, total: 0 };
      bucket.count++;
      bucket.total += item.review.rating;
      genres.set(genre, bucket);
    }
    if (item.artist?.name) {
      const key = `${item.artist.artistSource}:${item.artist.sourceId || item.artist.name}`;
      const bucket = artists.get(key) ?? { key, label: item.artist.name, count: 0, total: 0 };
      bucket.count++;
      bucket.total += item.review.rating;
      artists.set(key, bucket);
    }
  });
  const buckets = [...genres]
    .map(([label, g]) => ({ label, count: g.count, average: g.total / g.count }))
    .sort((a, b) => b.count - a.count || a.label.localeCompare(b.label));
  const lovedGenre = buckets
    .filter((g) => g.count >= 5)
    .sort(
      (a, b) => b.average - a.average || b.count - a.count || a.label.localeCompare(b.label),
    )[0];
  const topArtist = [...artists.values()].sort(
    (a, b) =>
      b.count - a.count || b.total / b.count - a.total / a.count || a.label.localeCompare(b.label),
  )[0];
  const reviews = records.filter((r) => plainReview(r.review.content).length > 0);
  const perfect = records.filter((r) => r.review.rating === 5);
  const rankedArtists = [...artists.values()].sort(
    (a, b) =>
      b.count - a.count || b.total / b.count - a.total / a.count || a.key.localeCompare(b.key),
  );
  const divergence = records
    .filter(
      (r) =>
        (r.album.editionCommunityCount ?? 0) >= 5 &&
        r.album.editionCommunityAverage != null &&
        Number.isFinite(r.album.editionCommunityAverage) &&
        r.album.editionCommunityAverage >= 0 &&
        r.album.editionCommunityAverage <= 5,
    )
    .map((r) => ({ record: r, difference: r.review.rating - r.album.editionCommunityAverage }))
    .filter((r) => Math.abs(r.difference) >= 1)
    .sort(
      (a, b) =>
        Math.abs(b.difference) - Math.abs(a.difference) || a.record.album.id - b.record.album.id,
    );
  const discoveries = records
    .filter((r) => {
      const released = editionTimestamp(r.album.releaseDate ?? '');
      const recorded = editionTimestamp(r.review.createdAt);
      return (
        Number.isFinite(released) &&
        Number.isFinite(recorded) &&
        new Date(recorded).getUTCFullYear() - new Date(released).getUTCFullYear() >= 10
      );
    })
    .sort(
      (a, b) =>
        editionTimestamp(a.album.releaseDate) - editionTimestamp(b.album.releaseDate) ||
        a.album.id - b.album.id,
    );
  const months = new Map();
  records.forEach((r) => {
    const date = new Date(editionTimestamp(r.review.createdAt));
    if (!Number.isFinite(date.getTime())) return;
    const key = `${date.getUTCFullYear()}.${String(date.getUTCMonth() + 1).padStart(2, '0')}`;
    months.set(key, [...(months.get(key) ?? []), r]);
  });
  const seasons = [...months]
    .sort(([a], [b]) => a.localeCompare(b))
    .slice(-4)
    .map(([month, rows]) => {
      const genres = new Map();
      rows.forEach((r) =>
        editionGenres(r.album.genres).forEach((g) => genres.set(g, (genres.get(g) ?? 0) + 1)),
      );
      return {
        month,
        count: rows.length,
        average: rows.reduce((sum, r) => sum + r.review.rating, 0) / rows.length,
        genre: [...genres].sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]))[0]?.[0] ?? '',
        record: rows[0],
      };
    });
  const words = reviewWords(reviews);
  const scenes = ['cover', 'stars'];
  if (buckets.length) scenes.push('genres');
  if (topArtist && topArtist.count >= 2) scenes.push('artist');
  if (reviews.length) scenes.push('quote');
  if (divergence.length) scenes.push('divergence');
  if (discoveries.length) scenes.push('discovery');
  if (seasons.length >= 2) scenes.push('seasons');
  if (words.length) scenes.push('words');
  if (rankedArtists.length >= 3) scenes.push('festival');
  if (perfect.length && records.some((r) => r.review.rating !== 5) && records.length >= 3)
    scenes.push('quiz');
  scenes.push('card');
  return {
    records,
    reviews,
    perfect,
    genres: buckets,
    lovedGenre,
    topArtist,
    rankedArtists,
    divergence,
    discoveries,
    seasons,
    words,
    scenes,
    perfectShare: records.length ? perfect.length / records.length : 0,
    count: records.length,
    reviewCount: reviews.length,
    average: records.length
      ? records.reduce((sum, r) => sum + r.review.rating, 0) / records.length
      : 0,
  };
}
// Visibility is not eligibility: every current style stays in the carousel.
// `scenes` on MusicEdition continues to describe the available evidence.
export const archiveScenes = [
  'card',
  'stars',
  'genres',
  'artist',
  'quote',
  'divergence',
  'discovery',
  'seasons',
  'words',
  'festival',
  'persona',
  'quiz',
  'duet',
];
export function editionMissingReason(scene, e, en = false) {
  const l = (ko, english) => (en ? english : ko);
  if (!e.count)
    return l(
      '선택한 기간에 평가한 앨범이 없어요. 첫 평가를 남기면 이 장면이 채워집니다.',
      'No rated albums in this period. Your first rating will begin this scene.',
    );
  if (scene === 'stars' && !e.perfect.length)
    return l(
      '아직 별 다섯 개를 남긴 앨범이 없어요. 만점을 남기면 이곳에 모입니다.',
      'No five-star albums yet. Your perfect scores will appear here.',
    );
  if (e.scenes.includes(scene) || scene === 'persona' || scene === 'duet') return undefined;
  if (
    scene === 'divergence' &&
    !e.records.some(
      (r) =>
        (r.album.editionCommunityCount ?? 0) >= 5 &&
        Number.isFinite(r.album.editionCommunityAverage),
    )
  )
    return l(
      '비교할 다른 회원의 평가가 부족해요. 다른 회원 5명 이상의 평가가 모인 앨범부터 비교합니다.',
      'There are not enough other-member ratings. Comparison starts with five other raters per album.',
    );
  if (
    scene === 'discovery' &&
    !e.records.some(
      (r) =>
        Number.isFinite(editionTimestamp(r.album.releaseDate ?? '')) &&
        Number.isFinite(editionTimestamp(r.review.createdAt)),
    )
  )
    return l(
      '발매일과 평가일을 확인할 수 있는 앨범이 없어 아직 재발견을 찾을 수 없어요.',
      'Release and rating dates are unavailable, so rediscoveries cannot yet be identified.',
    );
  if (scene === 'words' && e.reviews.length < 2)
    return l(
      '글로 남긴 리뷰가 2개 이상 필요해요. 여러 리뷰에 반복된 단어를 모아 보여드립니다.',
      'At least two written reviews are needed to find recurring words.',
    );
  const reasons = {
    genres: l(
      '평가한 앨범에 장르 정보가 없어 아직 비교할 수 없어요.',
      'Your rated albums have no genre information to compare.',
    ),
    artist: l(
      '같은 아티스트의 서로 다른 앨범 2장 이상에 평가를 남기면 보여드려요. 본문 리뷰는 없어도 됩니다.',
      'Rate at least two different albums by one artist. Written reviews are optional.',
    ),
    quote: l(
      '아직 글로 남긴 리뷰가 없어요. 리뷰를 작성하면 마음에 드는 문장을 고를 수 있어요.',
      'No written reviews yet. Write a review to choose a passage.',
    ),
    divergence: l(
      '다른 회원 평가가 5명 이상이고, 내 점수와 평균이 1점 이상 다른 앨범이 아직 없어요.',
      'No album yet has five other raters and a difference of at least one point from your score.',
    ),
    discovery: l(
      '평가한 해와 발매 연도가 10년 이상 차이 나는 앨범이 아직 없어요.',
      'No rated album yet was released at least ten calendar years before your rating.',
    ),
    seasons: l(
      '서로 다른 두 달 이상에 평가 기록이 쌓이면 시간에 따른 취향을 보여드려요.',
      'Ratings from at least two different months will reveal your taste over time.',
    ),
    words: l(
      '서로 다른 리뷰 2개 이상에 반복된 분석 대상 단어가 아직 없어요.',
      'No eligible word appears in at least two different reviews yet.',
    ),
    festival: l(
      '서로 다른 아티스트 3명 이상의 앨범을 평가하면 나만의 라인업이 만들어져요.',
      'Rate albums by at least three artists to build your lineup.',
    ),
    quiz: l(
      '평가한 앨범 3장 이상, 만점 앨범과 만점이 아닌 앨범이 모두 있어야 퀴즈를 만들 수 있어요.',
      'A quiz needs at least three rated albums, including both perfect and non-perfect scores.',
    ),
  };
  return reasons[scene];
}
// Fit whole square covers into a bounded area; center incomplete final rows.
export function editionCoverGrid(count, width, maxHeight, top, gap = 4, columns) {
  if (!count) return [];
  const cols = columns ?? (count === 1 ? 1 : count === 3 ? 3 : count <= 4 ? 2 : count <= 9 ? 3 : 4);
  const rows = Math.ceil(count / cols);
  const side = Math.min((width - gap * (cols - 1)) / cols, (maxHeight - gap * (rows - 1)) / rows);
  const actualHeight = rows * side + (rows - 1) * gap;
  return Array.from({ length: count }, (_, i) => {
    const row = Math.floor(i / cols),
      inRow = Math.min(cols, count - row * cols);
    return {
      x: (360 - (inRow * side + (inRow - 1) * gap)) / 2 + (i % cols) * (side + gap),
      y: top + (maxHeight - actualHeight) / 2 + row * (side + gap),
      side,
    };
  });
}
export function compareEditions(mine, other) {
  const byId = new Map(other.records.map((r) => [r.album.id, r]));
  const shared = mine.records.flatMap((me) => {
    const theirs = byId.get(me.album.id);
    return theirs
      ? [
          {
            me,
            otherRating: theirs.review.rating,
            difference: me.review.rating - theirs.review.rating,
          },
        ]
      : [];
  });
  return {
    count: shared.length,
    favorites: shared.filter((r) => r.me.review.rating >= 4 && r.otherRating >= 4).slice(0, 3),
    differences: [...shared]
      .filter((r) => Math.abs(r.difference) >= 1)
      .sort(
        (a, b) => Math.abs(b.difference) - Math.abs(a.difference) || a.me.album.id - b.me.album.id,
      )
      .slice(0, 3),
  };
}
export function editionHighlights(available) {
  const story = [
    'cover',
    'stars',
    'quote',
    'genres',
    'divergence',
    'festival',
    'seasons',
    'discovery',
    'artist',
    'words',
    'persona',
    'quiz',
    'duet',
  ];
  return [...story.filter((s) => available.includes(s)).slice(0, 7), 'card'];
}
export function reorderEditionAlbums(ids, from, to) {
  if (!Number.isInteger(from) || !Number.isInteger(to) || from < 0 || from >= ids.length)
    return [...ids];
  const result = [...ids];
  const destination = Math.max(0, Math.min(ids.length - 1, to));
  result.splice(destination, 0, result.splice(from, 1)[0]);
  return result;
}
export function selectEditionAlbums(records, selectedIds) {
  const byId = new Map(records.map((r) => [r.album.id, r]));
  if (selectedIds !== null)
    return [...new Set(selectedIds)]
      .flatMap((id) => (byId.get(id) ? [byId.get(id)] : []))
      .slice(0, 9);
  const chosen = [];
  const seen = new Set();
  const recentFavorite = [...records]
    .filter((r) => r.review.rating >= 4)
    .sort(
      (a, b) =>
        (editionTimestamp(b.review.createdAt) || 0) - (editionTimestamp(a.review.createdAt) || 0) ||
        b.review.rating - a.review.rating,
    )[0];
  const candidates = [
    ...records.slice(0, 1),
    ...(recentFavorite ? [recentFavorite] : []),
    ...records,
  ];
  for (const r of candidates) {
    const key = r.artist
      ? `${r.artist.artistSource}:${r.artist.sourceId || r.artist.name}`
      : `album:${r.album.id}`;
    if (!seen.has(key)) {
      chosen.push(r);
      seen.add(key);
    }
    if (chosen.length === 9) break;
  }
  return [...chosen, ...records.filter((r) => !chosen.includes(r))].slice(0, 9);
}
// Upper bounds measured from the bundled Pretendard Regular/SemiBold OTFs.
// Keep both preview/export deterministic, including wide W/M and narrow i/l.
const asciiAdvances = [
  0.251, 0.291, 0.379, 0.617, 0.623, 0.928, 0.635, 0.202, 0.375, 0.375, 0.517, 0.645, 0.278, 0.444,
  0.273, 0.359, 0.639, 0.459, 0.603, 0.632, 0.646, 0.618, 0.633, 0.568, 0.631, 0.633, 0.273, 0.273,
  0.645, 0.645, 0.645, 0.519, 0.88, 0.694, 0.631, 0.714, 0.696, 0.583, 0.561, 0.725, 0.715, 0.259,
  0.537, 0.65, 0.542, 0.873, 0.718, 0.745, 0.618, 0.746, 0.625, 0.623, 0.632, 0.708, 0.694, 0.971,
  0.662, 0.675, 0.625, 0.375, 0.359, 0.375, 0.459, 0.458, 0.475, 0.55, 0.605, 0.553, 0.605, 0.568,
  0.358, 0.599, 0.587, 0.245, 0.245, 0.544, 0.245, 0.865, 0.584, 0.583, 0.599, 0.599, 0.377, 0.525,
  0.361, 0.583, 0.552, 0.806, 0.539, 0.552, 0.537, 0.375, 0.339, 0.375, 0.645,
];
export function editionTextWidth(value, fontSize) {
  return Array.from(value).reduce((sum, char) => {
    const code = char.codePointAt(0);
    const em = code >= 32 && code <= 126 ? asciiAdvances[code - 32] : code > 0xffff ? 1.25 : 1.05;
    return sum + (em + 0.025) * fontSize;
  }, 0);
}
// Deterministic line wrapping shared by the preview and high-resolution image.
export function wrapEditionText(value, width, fontSize, maxLines) {
  const result = [];
  let line = '';
  let used = 0;
  const chars = Array.from(value.replace(/\s+/g, ' ').trim());
  for (let index = 0; index < chars.length; index++) {
    const char = chars[index];
    const size = editionTextWidth(char, fontSize);
    if (used + size > width && line) {
      const lastSpace = line.lastIndexOf(' ');
      // Keep normal words together; split only a token wider than the line.
      if (lastSpace > 0 && char !== ' ') {
        const carried = line.slice(lastSpace + 1);
        result.push(line.slice(0, lastSpace).trim());
        line = carried;
        used = editionTextWidth(carried, fontSize);
        if (result.length === maxLines) return ellipsize(result, width, fontSize);
      } else {
        result.push(line.trim());
        line = '';
        used = 0;
        if (result.length === maxLines) return ellipsize(result, width, fontSize);
      }
    }
    // A carried token can itself overflow when its next glyph is much wider.
    if (line && used + size > width) {
      result.push(line.trim());
      line = '';
      used = 0;
      if (result.length === maxLines) return ellipsize(result, width, fontSize);
    }
    line += char;
    used += size;
  }
  if (line) result.push(line.trim());
  return result;
}
// Shared by input, stored preferences and export: at most two actual card lines.
export function limitEditionIntro(value) {
  const chars = Array.from(value.replace(/\s+/g, ' ').trimStart()).slice(0, 60);
  while (
    chars.length &&
    wrapEditionText(chars.join(''), 300, 17, 2).join('').replace(/\s/g, '') !==
      chars.join('').replace(/\s/g, '')
  )
    chars.pop();
  return chars.join('');
}
export function fitEditionText(value, width, size, maxLines) {
  const normalized = value.replace(/\s/g, '');
  while (
    size > 1 &&
    wrapEditionText(value, width, size, maxLines).join('').replace(/\s/g, '') !== normalized
  )
    size -= 0.25;
  return { size, rows: wrapEditionText(value, width, size, maxLines) };
}
function ellipsize(lines, width, fontSize) {
  const chars = Array.from(lines[lines.length - 1]);
  while (chars.length && editionTextWidth(`${chars.join('')}…`, fontSize) > width) chars.pop();
  lines[lines.length - 1] = `${chars.join('').trimEnd()}…`;
  return lines;
}
